import { useContext } from 'react';

import { LayoutContext } from '..';
import useRightPanelLayout from './useRightPanelLayout';
import useBottomPanelLayout from './useBottomPanelLayout';
import useTradePanelLayout from './useTradePanelLayout';

export default function useLayout() {
  const context = useContext(LayoutContext);

  const rightPanel = useRightPanelLayout();
  const bottomPanel = useBottomPanelLayout();
  const tradePanel = useTradePanelLayout();

  const isReady = context?.isReady || false;

  return {
    isReady,
    rightPanel,
    bottomPanel,
    tradePanel,
    refs: context.refs,
  };
}
